import { classifyD1Cause } from './classify-d1-cause';
import { resolveEventCause } from './resolve-event-cause';

interface ISentryExceptionValue {
  type?: string;
  value?: string;
}

interface ISentryEventLike {
  exception?: { values?: ISentryExceptionValue[] };
  extra?: Record<string, unknown>;
}

interface IMutableSentryEvent extends ISentryEventLike {
  contexts?: { dbError?: { cause?: unknown } };
  fingerprint?: string[];
}

interface ISentryHintLike {
  originalException?: unknown;
}

const DRIZZLE_QUERY_PREFIX = 'Failed query:';
const GENERIC_QUERY_TITLE = 'D1 query failed';

export function promoteCauseToTitle<TEvent extends ISentryEventLike>(
  event: TEvent,
  hint?: ISentryHintLike,
): TEvent {
  const values = event.exception?.values;
  const main = values?.at(-1);
  if (!values || values.length === 0 || !main?.value) {
    return event;
  }

  const mutable = event as IMutableSentryEvent;
  const cause = resolveEventCause(hint?.originalException, mutable.contexts?.dbError?.cause);
  const isDrizzleWrapper = main.value.startsWith(DRIZZLE_QUERY_PREFIX);

  if (cause && main.value !== cause) {
    mutable.extra = { ...event.extra, wrappedError: main.value };
    main.value = cause;
  }

  if (!isDrizzleWrapper) {
    return event;
  }

  if (!cause) {
    mutable.extra = { ...event.extra, wrappedError: main.value };
    main.value = GENERIC_QUERY_TITLE;
  }
  mutable.fingerprint = ['d1-query-failed', classifyD1Cause(cause ?? main.value)];
  return event;
}
